import brandConstants from './brand-constants';
const baseMuiTheme = {
    palette: {
        primary: {
            main: brandConstants.colors.primary,
            light: brandConstants.colors.primary_light,
            contrastText: brandConstants.colors.white,
        },
        secondary: {
            main: brandConstants.colors.secondary,
            light: brandConstants.colors.third,
            contrastText: brandConstants.colors.white,
        },
        text: {
            primary: '#222222',
            secondary: '#656565',
            third: brandConstants.colors.third,
            disabled: brandConstants.colors.light_grey,
            grayText: brandConstants.colors.bg_amended_text,
            amendedText: brandConstants.colors.amended_text,
        },
        background: {
            default: '#FFF',
            alternate: brandConstants.colors.bg_alternative,
            header: brandConstants.colors.secondary_dark,
            label: brandConstants.colors.bg_third,
            processingStatus: brandConstants.colors.bg_processing,
            approvedStatus: brandConstants.colors.bg_approved,
            conditionallyApprovedStatus: brandConstants.colors.bg_conditionally_approved,
            conditionallyApprovedStatusBorder: brandConstants.colors.bg_conditionally_approved_border,
            declinedStatus: brandConstants.colors.bg_decline_cancelled,
            amendedStatus: brandConstants.colors.bg_amended,
        },
        warning: {
            main: brandConstants.colors.warning_main || '#FF9800',
            light: brandConstants.colors.processing_status,
        },
        primaryDisabled: {
            main: brandConstants.colors.primary_disabled,
        },
    },
    typography: {
        fontFamily: brandConstants.fontFamilies.primary,
        fontFamily2: brandConstants.fontFamilies.primary_bold,
        fontFamily3: brandConstants.fontFamilies.heavy,
        fontSize: 10,
        htmlFontSize: 10,
        fontWeightBold: 700,
        body1: {
            fontSize: brandConstants.fontSizes.md,
            [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                fontSize: brandConstants.fontSizes.md,
            },
        },
        body2: {
            fontSize: brandConstants.fontSizes.sm,
            [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                fontSize: brandConstants.fontSizes.xs,
            },
        },
        h1: {
            fontSize: brandConstants.fontSizes.xxl,
            letterSpacing: 3,
            color: brandConstants.colors.primary,
        },
        h2: {
            fontSize: brandConstants.fontSizes.xxl,
            color: brandConstants.colors.primary,
            fontWeight: 700,
        },
        h3: {
            fontSize: brandConstants.fontSizes.xxl,
            marginBottom: '1rem',
            [`@media (max-width:${brandConstants.screens.md}px)`]: {
                fontSize: brandConstants.fontSizes.xl,
            },
        },
        h4: {
            fontSize: brandConstants.fontSizes.xl,
            [`@media (max-width:${brandConstants.screens.md}px)`]: {
                fontSize: brandConstants.fontSizes.lg,
            },
        },
        h5: {
            fontSize: brandConstants.fontSizes.lg,
            fontWeight: 700,
            [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                fontSize: brandConstants.fontSizes.md,
            },
        },
        subtitle1: {
            fontSize: brandConstants.fontSizes.md,
            [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                fontSize: brandConstants.fontSizes.sm,
            },
        },
        subtitle2: {
            fontSize: brandConstants.fontSizes.sm,
            fontWeight: 700,
        },
        caption: {
            fontSize: brandConstants.fontSizes.sm,
            [`@media (max-width:${brandConstants.screens.md}px)`]: {
                fontSize: brandConstants.fontSizes.xs,
            },
        },
        captionHeavy: {
            captionHeavy: true,
        },
        helpingText: {
            helpingText: true,
        },
        sectionTitle: {
            fontSize: brandConstants.fontSizes.xl,
            fontFamily: brandConstants.fontFamilies.primary,
            [`@media (max-width:${brandConstants.screens.md}px)`]: {
                fontSize: brandConstants.fontSizes.lg,
            },
        },
        fontXXL: brandConstants.fontSizes.xxl,
        fontXL: brandConstants.fontSizes.xl,
        fontLG: brandConstants.fontSizes.lg,
        fontMD: brandConstants.fontSizes.md,
        fontSM: brandConstants.fontSizes.sm,
        fontXS: brandConstants.fontSizes.xs,
        fontXXS: brandConstants.fontSizes.xxs,
    },
};
export default baseMuiTheme;
//# sourceMappingURL=base-mui-theme.js.map